import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
export const WhatYouGetSection = () => {
  const deliverables = [{
    title: 'El Ebook Maestro RENACER',
    desc: 'Con los 3 módulos de transformación completa.'
  }, {
    title: 'Técnica de Desconexión de Memoria Celular',
    desc: 'Para cortar hilos con el pasado.'
  }, {
    title: 'El Protocolo de Acceso al Punto Cero',
    desc: 'Para silenciar el ruido mental.'
  }, {
    title: 'Meditación de Reescritura Cuántica',
    desc: 'El paso a paso para elegir tu nueva identidad.'
  }, {
    title: 'Mapa de Sincronicidades',
    desc: 'Cómo leer las señales del campo cuántico.'
  }, {
    title: 'Glosario de Terminología Cuántica',
    desc: 'Para el nuevo observador.'
  }];
  return <section className="py-24 px-4 relative border-t border-sand bg-parchment-dark/50" data-id="element-188">
      <div className="max-w-5xl mx-auto" data-id="element-189">
        <FadeIn data-id="element-190">
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-center mb-16 text-brown-heading" data-id="element-191">
            Lo que <span className="gold-gradient-text" data-id="element-192">recibes</span> hoy
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-193">
          {deliverables.map((item, index) => <FadeIn key={index} delay={0.1 * (index + 1)} data-id="element-194">
              <div className="flex gap-4 p-6 rounded-xl bg-parchment border border-sand hover:border-gold/40 transition-all duration-300 group" data-id="element-195">
                <div className="flex-shrink-0 mt-1" data-id="element-196">
                  <CheckCircle2 className="text-gold-antique group-hover:scale-110 transition-transform" size={24} data-id="element-197" />
                </div>
                <div data-id="element-198">
                  <h3 className="text-lg font-semibold text-brown-heading mb-1" data-id="element-199">
                    {item.title}
                  </h3>
                  <p className="text-brown-warm/60 text-sm leading-relaxed" data-id="element-200">
                    {item.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
};